import {useDispatch} from 'react-redux'
import Modal from '@/components/modals/Modal/Modal'
import Button from '@/components/ui/Button/Button'
import IconButton from '@/components/ui/IconButton/IconButton'
import IconClose from '@/assets/icons/icon-close.svg?react'
import IconLogo from '@/assets/icons/img-logo.svg?react'
import {TextH2, TextMidd, TextNorm} from '@/components/ui/Text'
import {getBillingUrlSaga} from '@/store/workspace/workspaceSlice'
import {useAppSelector} from '@/store/hooks'
import {selectIsLoading} from '@/store/ui/uiSelectors'
import {selectWorkspace} from '@/store/workspace/workspaceSelectors'
import {AnalyticsEvent, trackEvent} from '@/lib/analytics'
import css from './UpgradeToProModal.module.css'

interface UpgradeToProModalProps {
    onClose: () => void
}

const UpgradeToProModal = ({onClose}: UpgradeToProModalProps) => {
    const dispatch = useDispatch()
    const isLoading = useAppSelector(selectIsLoading('get-billing-url'))
    const workspaceId = useAppSelector(selectWorkspace)?.id

    const handleUpgrade = () => {
        // Tracked before the dispatch so the Stripe redirect can't drop the event.
        trackEvent(AnalyticsEvent.UpgradeClicked, {source: 'limit_modal', workspace_id: workspaceId})
        dispatch(getBillingUrlSaga())
    }

    return (
        <Modal onClose={onClose} maxWidth={416}>
            <div className={css.buttons}>
                <IconButton icon={<IconClose />} onClick={onClose} />
            </div>
            <div className={css.logo}>
                <IconLogo />
            </div>
            <TextH2>You’ve reached your limit</TextH2>
            <div className={css.content}>
                <TextNorm>The free plan includes limited projects and tasks. Upgrade to Pro to keep growing your workspace without restrictions.</TextNorm>
            </div>
            <div className={css.submit}>
                <Button
                    title="Upgrade to Pro"
                    type="black"
                    size="medium"
                    onClick={handleUpgrade}
                    loading={isLoading}
                />
            </div>
            <div className={css.info}>
                <TextMidd>$8 per member / month</TextMidd>
            </div>
        </Modal>
    )
}

export default UpgradeToProModal
